// Mock data for Excelence Inc — Auto Transport & Logistics

export const COMPANY = {
  name: 'Excelence Inc',
  tagline: 'Precision Logistics. Elite Performance. Nationwide Reach.',
  phone: '(718) 490-4076',
  phoneHref: 'tel:+17184904076',
  email: 'info@excelenceinc.com',
  emailHref: 'mailto:info@excelenceinc.com',
  website: 'www.excelenceinc.com',
  location: 'New York, USA',
  established: 2024,
  mc: 'MC1766140',
  dot: 'DOT4474028',
  logo: '/brand/logo.png',
};

export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Partners', href: '/partners' },
  { label: 'Drive With Us', href: '/drivers' },
  { label: 'Coordinators', href: '/careers' },
  { label: 'Contact', href: '/contact' },
];

export const HERO_IMAGES = {
  main: 'https://images.pexels.com/photos/2199293/pexels-photo-2199293.jpeg?auto=compress&cs=tinysrgb&w=2000',
  open: 'https://images.pexels.com/photos/29566910/pexels-photo-29566910.jpeg?auto=compress&cs=tinysrgb&w=1600',
  enclosed: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop',
  expedited: 'https://images.pexels.com/photos/29566897/pexels-photo-29566897.jpeg?auto=compress&cs=tinysrgb&w=1600',
  door: 'https://images.unsplash.com/photo-1617469767053-d3b523a0b982?q=80&w=1200&auto=format&fit=crop',
  ops: 'https://images.pexels.com/photos/29566910/pexels-photo-29566910.jpeg?auto=compress&cs=tinysrgb&w=1600',
  broker: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?q=80&w=1600&auto=format&fit=crop',
};

export const BROKER_LOGOS = [
  { name: 'Central Dispatch', mark: 'CD' },
  { name: 'Super Dispatch', mark: 'SD' },
  { name: 'Copart', mark: 'CP' },
  { name: 'IAA', mark: 'IAA' },
  { name: 'ACERTUS', mark: 'AC' },
  { name: 'Carvana', mark: 'CV' },
  { name: 'RunBuggy', mark: 'RB' },
  { name: 'RPM Moves', mark: 'RPM' },
  { name: 'Ship.Cars', mark: 'SC' },
  { name: 'Ready Logistics', mark: 'RL' },
  { name: 'uShip', mark: 'uS' },
  { name: 'CarsArrive', mark: 'CA' },
];

export const ELITE_SERVICES = [
  {
    id: 'open',
    tag: 'High-Volume Efficiency',
    title: 'Open Auto Transport',
    copy: 'Multi-car haulers and optimized routing deliver the most efficient, cost-effective open transport across the United States. Ideal for dealerships, auctions, brokers and personal moves.',
    bullets: ['Multi-vehicle cost savings', 'Nationwide lane coverage', 'Daily dispatch windows'],
    image: 'https://images.pexels.com/photos/29566910/pexels-photo-29566910.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 'enclosed',
    tag: 'White-Glove Protection',
    title: 'Enclosed Auto Transport',
    copy: 'For luxury, classic, exotic and collector vehicles — premium protection from weather, debris and road exposure. Climate-controlled trailers and trained specialists.',
    bullets: ['Soft-strap tie-downs', 'Liftgate loading', 'Insured up to $1M cargo'],
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'expedited',
    tag: 'Speed Without Compromise',
    title: 'Expedited Transport',
    copy: 'When timing matters, our dispatch systems prioritize urgent shipments and optimize routes for fast, reliable delivery — measured in hours, not days.',
    bullets: ['24–48 hr priority pickup', 'Dedicated driver & route', 'SLA-backed transit times'],
    image: 'https://images.pexels.com/photos/29566897/pexels-photo-29566897.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 'broker',
    tag: 'Built for Volume',
    title: 'Broker & Dealer Logistics',
    copy: 'Recurring moves, auction releases, dealership transfers, fleet relocations and scalable logistics support — engineered for volume partners.',
    bullets: ['Auction pickup specialists', 'Fleet relocation teams', 'Net-terms available'],
    image: 'https://images.unsplash.com/photo-1617469767053-d3b523a0b982?q=80&w=1600&auto=format&fit=crop',
  },
];

export const WHY_PILLARS = [
  {
    n: '01',
    title: 'Systematic Control',
    copy: 'Every mile is planned. Every load is monitored. Our dispatch systems reduce delays and maximize efficiency across the network.',
  },
  {
    n: '02',
    title: 'Professional Equipment',
    copy: 'Reliable trucks, professional carriers, and scalable trailer capacity for single units or large-volume, multi-unit transport.',
  },
  {
    n: '03',
    title: 'Broker Confidence',
    copy: 'Trusted by leading brokers, auctions and transportation platforms nationwide — accepted on all major loadboards.',
  },
  {
    n: '04',
    title: 'Full Transparency',
    copy: 'Real-time updates, digital paperwork, photo documentation at pickup & delivery, and responsive communication throughout.',
  },
  {
    n: '05',
    title: 'Fast Response Team',
    copy: 'Quotes, dispatch updates, and issue resolution handled quickly by trained coordinators — available when you need them.',
  },
];

export const CASE_STUDIES = [
  {
    tag: 'Urgent Delivery',
    kpi: '72 hrs',
    kpiLabel: 'Coast-to-coast',
    title: '72-Hour Priority Delivery',
    copy: 'Completed an urgent long-distance multi-vehicle shipment on schedule with zero damage — coordinated across three time zones.',
    image: 'https://images.pexels.com/photos/93398/pexels-photo-93398.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    tag: 'Auction Specialist',
    kpi: '98.4%',
    kpiLabel: 'On-time pickup',
    title: 'Auction Release Specialists',
    copy: 'Managing recurring Copart & IAA pickups with high on-time performance, organized release paperwork and same-day dispatch.',
    image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?q=80&w=1600&auto=format&fit=crop',
  },
  {
    tag: 'Dealer Growth',
    kpi: '2.4×',
    kpiLabel: 'Inventory velocity',
    title: 'Dealer Growth Partner',
    copy: 'Helping dealerships move inventory faster with dependable nationwide transport capacity and predictable, transparent rates.',
    image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?q=80&w=1600&auto=format&fit=crop',
  },
];

export const RECRUITMENT_ROLES = [
  'Owner Operators',
  'CDL Drivers',
  'Car Haulers',
  'Dispatch Professionals',
  'Logistics Coordinators',
];

export const ELITE_REVIEWS = [
  { name: 'Marcus R.', role: 'Dealer Partner · Texas', copy: 'Fast communication and reliable pickup times. They became our go-to for auction releases in under a month.' },
  { name: 'Priya S.', role: 'Retail Customer · CA → NY', copy: 'Honest pricing and a smooth delivery process. Driver kept me updated the whole way — exactly what I wanted.' },
  { name: 'Daniel K.', role: 'Broker · Illinois', copy: 'Easy to work with and professional team. Dispatch answers fast and their paperwork is airtight.' },
  { name: 'Sophia L.', role: 'Dealer · Florida', copy: 'Great broker partner with strong follow-through. Invoicing is clean, communication is top-tier.' },
  { name: 'Ethan M.', role: 'Owner Operator', copy: 'Loads are well-organized and payments are on time. Rare combination in this industry.' },
  { name: 'Amelia W.', role: 'Private Collector', copy: 'Enclosed transport for my classic car was flawless. Arrived spotless, driver was a pro start to finish.' },
];

export const VEHICLE_TYPES = [
  'Sedan', 'SUV', 'Pickup Truck', 'Luxury Car', 'Oversized Vehicle',
  'Motorcycle', 'Classic Car'
];

export const SERVICES = [
  {
    id: 'open',
    title: 'Open Auto Transport',
    image: 'https://images.pexels.com/photos/29566910/pexels-photo-29566910.jpeg?auto=compress&cs=tinysrgb&w=1600',
    tag: 'Most Popular',
    description: 'The most cost-effective method for shipping vehicles. Cars are loaded onto an open trailer — typically two levels — allowing us to transport multiple vehicles efficiently across the country.',
    bullets: ['Affordable & efficient', 'Nationwide coverage', 'Ideal for everyday cars'],
  },
  {
    id: 'enclosed',
    title: 'Enclosed Auto Transport',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop',
    tag: 'Premium',
    description: 'Maximum protection for luxury, classic and exotic vehicles. Fully enclosed trailers shield your car from weather, dirt and road debris — arriving in pristine condition.',
    bullets: ['Climate-controlled trailers', 'White-glove handling', 'Ideal for high-value vehicles'],
  },
  {
    id: 'expedited',
    title: 'Expedited Shipping',
    image: 'https://images.pexels.com/photos/29566897/pexels-photo-29566897.jpeg?auto=compress&cs=tinysrgb&w=1600',
    tag: 'Fast',
    description: 'Need it fast? Priority pickup within 24–48 hours, dedicated drivers, and flexible scheduling for urgent relocations, dealer trades, and business moves.',
    bullets: ['Pickup in 24–48 hrs', 'Dedicated driver', 'Real-time updates'],
  },
];

export const AREAS = [
  { state: 'New York', copy: 'Reliable vehicle shipping to and from New York City and across the state. Long-distance, door-to-door service with open or enclosed options.' },
  { state: 'Florida', copy: 'Relocating to Miami, Orlando or Tampa? We specialize in secure auto transport to and from Florida with flexible pickup windows.' },
  { state: 'California', copy: 'Shipping to Los Angeles, San Francisco or San Diego — we handle cross-country moves with timely, transparent delivery.' },
  { state: 'Texas', copy: 'From Dallas to Houston and Austin, our carriers serve the entire Lone Star State with competitive rates and fast dispatch.' },
];

export const HOW_IT_WORKS = [
  { step: '01', title: 'Request a Quote', copy: 'Use our instant calculator. Enter pickup & delivery locations, vehicle details and preferred transport method. Quote in seconds.' },
  { step: '02', title: 'Vetted Carrier Pickup', copy: 'On your scheduled date, our professional, fully-vetted carrier arrives, inspects your vehicle and loads it securely.' },
  { step: '03', title: 'Delivery & Inspection', copy: 'We notify you before arrival. You inspect the car on delivery and confirm it matches the condition at pickup — simple as that.' },
];

export const STATS = [
  { value: '15,000+', label: 'Vehicles Shipped', sub: 'Coast-to-coast, door-to-door' },
  { value: '12,500+', label: 'Happy Customers', sub: 'Real reviews & returning clients' },
  { value: '4.9/5', label: 'Average Rating', sub: 'Based on verified shipments' },
  { value: '20,000+', label: 'Vetted Carriers', sub: 'Nationwide partner network' },
];

export const TESTIMONIALS = [
  { name: 'Jason Baker', route: 'Los Angeles, CA → Miami, FL', rating: 5, copy: 'The communication was fantastic. Shipped my Mercedes-Benz C-Class coast-to-coast and the driver kept me updated the whole way. Everything went exactly as planned.' },
  { name: 'Nicolas Watson', route: 'Seattle, WA → Dallas, TX', rating: 5, copy: 'I needed my Mazda CX-5 shipped ASAP, and Excelence got it done quickly and professionally. Great driver, no last-minute surprises.' },
  { name: 'Austin Orr', route: 'Tampa, FL → Chicago, IL', rating: 5, copy: 'I was nervous about shipping my 1969 Camaro, but the team handled it like pros. Enclosed trailer, fast delivery, constant updates. Highly recommend.' },
  { name: 'Cliff Hogan', route: 'New York, NY → San Diego, CA', rating: 5, copy: 'I rarely leave reviews, but Excelence Inc deserves five stars. Delivered my Dodge Ram in an open carrier — driver was early, truck arrived spotless.' },
  { name: 'Henry Murphy', route: 'Dallas, TX → Los Angeles, CA', rating: 5, copy: 'Clear communication, timely updates, and the car arrived just as described. Smooth engine, clean interior, zero hassle. Will use again.' },
  { name: 'Lachlan Nguyen', route: 'Chicago, IL → Miami, FL', rating: 5, copy: 'Realistic pricing and they managed my expectations on timing perfectly. Car is in great shape, no issues since delivery. Dependable service.' },
];

export const PRICING = {
  open: [
    { range: 'Short Distance (0–500 mi)', price: '$1.50 – $2.00 / mile' },
    { range: 'Medium Distance (500–1,500 mi)', price: '$1.00 – $1.50 / mile' },
    { range: 'Long Distance (1,500+ mi)', price: '$0.50 – $1.00 / mile' },
  ],
  enclosed: [
    { range: 'Short Distance (0–500 mi)', price: '$2.50 – $3.50 / mile' },
    { range: 'Medium Distance (500–1,500 mi)', price: '$1.50 – $1.90 / mile' },
    { range: 'Long Distance (1,500+ mi)', price: '$0.75 – $1.25 / mile' },
  ],
};

export const FAQS = [
  { q: 'Can I transport personal items in my car?', a: 'Yes — you can place personal belongings in the trunk, up to 100 lbs. Note that the carrier\u2019s insurance does not cover personal items, and exceeding the weight limit may result in additional fees.' },
  { q: 'Is my vehicle insured during transport?', a: 'Yes. Your vehicle is fully insured under the carrier\u2019s cargo insurance policy during transit. You\u2019ll receive documentation before shipping, and we do a full inspection prior to loading.' },
  { q: 'How do I arrange car pickup?', a: 'Once your order is placed, we search our network for the best carrier. Dispatch provides an ETA and the driver calls at least 24 hours ahead to confirm a convenient pickup time.' },
  { q: 'How long will my car take to ship?', a: 'Shipments within 500 miles typically take 1–3 days. Cross-country transports usually take 5–9 days. You receive an estimated delivery window at booking.' },
  { q: 'How can I track my car during shipping?', a: 'We offer 24/7 real-time tracking with updates at every stage — from driver assignment to pickup, transit and delivery to your door.' },
  { q: 'Is upfront payment required?', a: 'No. You only pay once your vehicle has been dispatched to a carrier. We accept credit/debit cards and electronic transfers — no hidden fees.' },
  { q: 'Can I get expedited shipping?', a: 'Yes — expedited service prioritizes pickup and delivery, often within 24–48 hours. Additional costs may apply depending on route and availability.' },
  { q: 'What types of vehicles do you transport?', a: 'Cars, SUVs, pickup trucks, motorcycles, classic and luxury vehicles. Both open and enclosed options are available based on your needs.' },
];

export const BLOG_POSTS = [
  {
    title: 'White-Glove Auto Transport | Luxury, Exotic & Classic Car Shipping',
    excerpt: 'When you need to ship a high-value vehicle, standard car transport may not feel like enough. Owners of luxury, exotic and classic cars deserve more.',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=900&auto=format&fit=crop',
    date: 'Apr 18, 2026',
    readTime: '6 min read',
  },
  {
    title: 'What Is the Best Car Shipping Company? A Buyer\u2019s Guide',
    excerpt: 'If you are trying to figure out the best car shipping company, the real answer isn\u2019t just one name — it\u2019s about fit, transparency and track record.',
    image: 'https://images.pexels.com/photos/2199293/pexels-photo-2199293.jpeg?auto=compress&cs=tinysrgb&w=900',
    date: 'Apr 12, 2026',
    readTime: '8 min read',
  },
  {
    title: 'Top Rated Motorcycle Shipping: How to Find a Trusted Company',
    excerpt: 'Searching for the top rated motorcycle shipping services? You\u2019re not just looking for the cheapest option — you want reliability and care.',
    image: 'https://images.pexels.com/photos/93398/pexels-photo-93398.jpeg?auto=compress&cs=tinysrgb&w=900',
    date: 'Apr 04, 2026',
    readTime: '5 min read',
  },
];
